<template>
  <div class="vue-codemirror"
       :class="{ merge }">
    <div v-if="merge"
         ref="mergeview">
    </div>
    <textarea v-else
              ref="textarea"
              :name="name"
              :placeholder="placeholder">
    </textarea>
  </div>
</template>
<script>
// lib
import CodeMirror from 'codemirror'
import Beautify from 'js-beautify'

// @see https://codemirror.net/mode/javascript/index.html
import 'codemirror/mode/javascript/javascript';

// import base style
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css'


// export
export default {
  name: 'codemirror-json',
  data() {
    return {
      content: '',
      codemirror: null,
      cmInstance: null
    }
  },
  props: {
    autoformat: {
      type: Boolean,
      default: true,
    },
    code: String,
    value: String,
    marker: Function,
    unseenLines: Array,
    name: {
      type: String,
      default: 'codemirror'
    },
    placeholder: {
      type: String,
      default: ''
    },
    merge: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      default: () => ([])
    },
    globalOptions: {
      type: Object,
      default: () => ({})
    },
    globalEvents: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    options: {
      deep: true,
      handler(options) {
        for (const key in options) {
          this.cmInstance.setOption(key, options[key])
        }
      }
    },
    merge() {
      this.$nextTick(this.switchMerge)
    },
    code(newVal) {
      this.handerCodeChange(newVal)
    },
    value(newVal) {
      this.handerCodeChange(newVal)
    },
  },
  methods: {
    // @see https://github.com/beautify-web/js-beautify
    autoFormatContent() {
      const editor = this.cmInstance;
      let value = editor.getValue();
      const options = {
        extra_liners: [],
      }
      editor.setValue(Beautify.js(value, options));
    },

    initialize() {
      const cmOptions = Object.assign({}, this.globalOptions, this.options)
      if (this.merge) {
        this.codemirror = CodeMirror.MergeView(this.$refs.mergeview, cmOptions)
        this.cmInstance = this.codemirror.edit
      } else {
        this.codemirror = CodeMirror.fromTextArea(this.$refs.textarea, cmOptions)
        this.cmInstance = this.codemirror
        this.cmInstance.setValue(this.code || this.value || this.content)
      }
      CodeMirror.commands['selectAll'](this.codemirror);
      this.cmInstance.on('change', cm => {
        this.content = cm.getValue()
        if (this.$emit) {
          this.$emit('input', this.content)
        }
      })

      const tmpEvents = {}
      const allEvents = [
        'scroll',
        'changes',
        'beforeChange',
        'cursorActivity',
        'keyHandled',
        'inputRead',
        'electricInput',
        'beforeSelectionChange',
        'viewportChange',
        'swapDoc',
        'gutterClick',
        'gutterContextMenu',
        'focus',
        'blur',
        'refresh',
        'optionChange',
        'scrollCursorIntoView',
        'update'
      ]
        .concat(this.events)
        .concat(this.globalEvents)
        .filter(e => (!tmpEvents[e] && (tmpEvents[e] = true)))
        .forEach(event => {
          // 循环事件，并兼容 run-time 事件命名
          this.cmInstance.on(event, (...args) => {
            // console.log('当有事件触发了', event, args)
            this.$emit(event, ...args)
            const lowerCaseEvent = event.replace(/([A-Z])/g, '-$1').toLowerCase()
            if (lowerCaseEvent !== event) {
              this.$emit(lowerCaseEvent, ...args)
            }
          })
        })

      this.$emit('ready', this.codemirror)
      this.unseenLineMarkers()

      // prevents funky dynamic rendering
      this.refresh()
    },
    refresh() {
      this.$nextTick(() => {
        this.cmInstance.refresh()
      })
    },
    destroy() {
      // garbage cleanup
      const element = this.cmInstance.doc.cm.getWrapperElement()
      element && element.remove && element.remove()
    },
    handerCodeChange(newVal) {
      const cm_value = this.cmInstance.getValue()
      if (newVal !== cm_value) {
        const scrollInfo = this.cmInstance.getScrollInfo()
        this.cmInstance.setValue(newVal)
        this.content = newVal
        this.cmInstance.scrollTo(scrollInfo.left, scrollInfo.top)
      }
      this.unseenLineMarkers()
    },
    unseenLineMarkers() {
      if (this.unseenLines !== undefined && this.marker !== undefined) {
        this.unseenLines.forEach(line => {
          const info = this.cmInstance.lineInfo(line)
          this.cmInstance.setGutterMarker(line, 'breakpoints', info.gutterMarkers ? null : this.marker())
        })
      }
    },
    switchMerge() {
      // Save current values
      const history = this.cmInstance.doc.history
      const cleanGeneration = this.cmInstance.doc.cleanGeneration
      this.options.value = this.cmInstance.getValue()

      this.destroy()
      this.initialize()

      // Restore values
      this.cmInstance.doc.history = history
      this.cmInstance.doc.cleanGeneration = cleanGeneration
    }
  },
  mounted() {
    this.initialize()
  },
  beforeDestroy() {
    this.destroy()
  }
}
</script>
